<template lang="pug">
  .send-email-dialog
    el-dialog(
      :title="$t(title)"
      :visible="visible"
      @close="$emit('cancel')"
      :close-on-click-modal="false"
      center
    )
      .send-email-dialog__form
        div
          .send-email-dialog__label {{ $t('收件人') }}
          span(style="line-height: 22px") {{ email }}
        div
          .send-email-dialog__label {{ $t('抄送') }}
          span(style="line-height: 22px") {{ cc }}
      div(style="text-align:center")
        el-button(
          type="primary"
          style="width: 140px"
          @click="$emit('confirm')"
        ) {{ $t('确认') }}
        el-button(
          style="width: 140px"
          @click="$emit('cancel')"
        ) {{ $t('取消') }}

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default () {
        return ''
      }
    },
    visible: {
      type: Boolean,
      default () {
        return false
      }
    },
    email: {
      type: String,
      isRequired: true
    },
    cc: {
      type: String
    }
  }
}
</script>

<style lang="stylus">
.send-email-dialog__form
  > div
    display flex
    margin 20px 50px

.send-email-dialog__label
  width: 45px
  text-align: right
  margin-right: 20px
  line-height: 25px
</style>
